import { Expose, Transform, Type } from "class-transformer";
import formatISO from "date-fns/formatISO";
import { observable } from "mobx";
import InvoiceListItemState from "./invoiceListItemState";
import SupplyPointSimple from "./supplyPointSimple";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class InvoiceListItem {
  id!: number;

  @observable
  @Expose({ name: "invoice_type_id" })
  invoiceTypeId!: number;

  /**
   * Amount
   */
  @observable
  amount!: number;

  /**
   * Amount paid
   */
  @observable
  @Expose({ name: "amount_paid" })
  amountPaid!: number;

  /**
   * Poplatky
   */
  @observable
  @Expose({ name: "amount_charge" })
  amountCharge!: number;

  @observable
  consumption!: number;

  @observable
  @Expose({ name: "consumption_nt" })
  consumptionNt?: number;

  @observable
  code!: string;

  @observable
  vs!: string;

  @observable
  @Expose({ name: "account_id" })
  accountId!: number;

  @observable
  state!: InvoiceListItemState;

  @observable
  @Expose({ name: "state_text" })
  stateText?: string;

  @observable
  @Transform(value => (value ? new Date(value) : undefined), { toClassOnly: true })
  @Transform(value => (value ? formatISO(value, { representation: "date" }) : undefined), { toPlainOnly: true })
  @Expose({ name: "due_date" })
  dueDate!: Date;

  @observable
  period!: string;

  @observable
  @Transform(value => (value ? new Date(value) : undefined), { toClassOnly: true })
  @Transform(value => (value ? formatISO(value, { representation: "date" }) : undefined), { toPlainOnly: true })
  @Expose({ name: "issue_date" })
  issueDate?: Date;

  @observable
  @Transform(value => (value ? new Date(value) : undefined), { toClassOnly: true })
  @Transform(value => (value ? formatISO(value, { representation: "date" }) : undefined), { toPlainOnly: true })
  @Expose({ name: "pay_date" })
  payDate?: Date;

  /**
   * Can we use payment GW or show code?
   */
  @observable
  @Expose({ name: "allow_to_pay" })
  allowToPay?: boolean;

  /**
   * Invoice file URL
   */
  @observable
  file?: string;

  /**
   * FICA Doklad
   */
  @observable
  @Expose({ name: "fica_document" })
  ficaDocument?: string;

  /**
   * Could we claim invoice?
   */
  @observable
  @Expose({ name: "allow_to_claim" })
  allowToClaim?: boolean;

  /**
   * Číslo účtu PP kam má být faktura uhrazena
   */
  @observable
  @Expose({ name: "account_number" })
  accountNumber?: string;

  @observable
  @Type(() => SupplyPointSimple)
  @Expose({ name: "supply_points" })
  supplyPoints!: SupplyPointSimple[];

  static ValidationRules = {
    id: { required: true, number: true },
    invoiceTypeId: { required: true, number: true },
    amount: { required: true, number: true },
    amountPaid: { required: true, number: true },
    amountCharge: { required: true, number: true },
    consumption: { required: true, number: true },
    consumptionNt: { number: true },
    code: { required: true },
    vs: { required: true },
    accountId: { required: true, number: true },
    state: { required: true },
    dueDate: { required: true, date: true },
    period: { required: true },
    issueDate: { date: true },
    payDate: { date: true },
    supplyPoints: { required: true },
  };
}
